import { Link, useNavigate } from "react-router-dom";
import { useOrder } from "../context/OrderContext";
import { PromoHeroBanner } from "./PromoBanner";

const STEP_LABELS = {
  product: "Product",
  quantity: "Quantity",
  petscreen: "PetScreen",
  whiteGlove: "Perfect Fit",
  summary: "Summary",
  checkout: "Checkout",
  upsell: "Add-ons",
  measurements: "Measurements",
  done: "Done",
};

export default function OrderLayout({ children, hideSteps = false }) {
  const { state, reset, stepNumber, stepCount } = useOrder();
  const navigate = useNavigate();
  const progress = Math.min(100, Math.round((stepNumber / Math.max(stepCount, 1)) * 100));

  const goHome = (e) => {
    e.preventDefault();
    reset();
    navigate("/");
  };

  return (
    <div className="min-h-screen flex flex-col" style={{ background: "#f7faf6" }}>
      <PromoHeroBanner />
      <header className="px-5 py-4 border-b bg-white sticky top-0 z-20">
        <div className="max-w-md mx-auto flex items-center justify-between">
          <Link to="/" data-testid="logo-link" onClick={goHome} className="flex items-center gap-2">
            <img
              src="https://customer-assets.emergentagent.com/job_tech-dispatch-31/artifacts/a6ta9f48_SCREENZZ-LOGO-RGB_TextOnly.png"
              alt="ScreenzZ"
              className="h-8"
            />
          </Link>
          <span className="step-pill" data-testid="step-pill">
            {hideSteps ? "Order" : `Step ${stepNumber} of ${stepCount}`}
          </span>
        </div>
        {!hideSteps && (
          <div className="max-w-md mx-auto mt-3">
            <div className="h-1.5 w-full rounded-full bg-[var(--brand-green-light)] overflow-hidden">
              <div
                data-testid="progress-bar"
                className="h-full brand-bg transition-all duration-300"
                style={{ width: `${progress}%` }}
              />
            </div>
            <p className="muted-text text-xs mt-1.5" data-testid="step-label">
              {STEP_LABELS[state.stepId] || ""}
            </p>
          </div>
        )}
      </header>

      <main className="flex-1 px-5 py-6">
        <div className="max-w-md mx-auto">{children}</div>
      </main>

      <footer className="py-6 text-center text-xs muted-text">
        <p>© {new Date().getFullYear()} ScreenzZ · DIY Ordering</p>
        <div className="flex items-center justify-center gap-4 mt-1 flex-wrap">
          <Link to="/choose-your-door" data-testid="footer-doors-link"
            className="text-[11px] muted-text hover:brand-text underline-offset-2 hover:underline">
            Browse doors
          </Link>
          <Link to="/lookup" data-testid="footer-lookup-link"
            className="text-[11px] muted-text hover:brand-text underline-offset-2 hover:underline">
            Track order
          </Link>
          <Link to="/privacy-policy" data-testid="footer-privacy-link"
            className="text-[11px] muted-text hover:brand-text underline-offset-2 hover:underline">
            Privacy
          </Link>
          <Link to="/terms" data-testid="footer-terms-link"
            className="text-[11px] muted-text hover:brand-text underline-offset-2 hover:underline">
            Terms
          </Link>
          <a href="tel:8774000889" data-testid="footer-contact-link"
            className="text-[11px] muted-text hover:brand-text underline-offset-2 hover:underline">
            Contact
          </a>
          <Link to="/admin/login" data-testid="footer-admin-link"
            className="text-[11px] muted-text hover:brand-text underline-offset-2 hover:underline">
            Admin
          </Link>
        </div>
      </footer>
    </div>
  );
}
